module.exports = __webpack_public_path__ + "media/images/fonts/HKGroteskPro/HKGroteskPro-Italic-586bf62e526ce406f07ea1c529c26692.otf";